import { ACTIONTYPE } from '../../enum';


export class ItemNode {
  actionkey = '';
  actiontype: ACTIONTYPE = ACTIONTYPE.VIDEO;
  actors = [];
  ad = '';
  ad_breaks: number[] | null = null;
  age_appropriate_rating = '';
  age_group = '';
  author = '';
  bg_image_landscape = '';
  bg_image_portrait = '';
  bgimage = '';
  blockItem = false;
  brands = '';
  catId = '';
  cc_path = '';
  content_genre: string | null = null;
  date = '';
  deeplink_url = '';
  description = '';
  directors = [];
  drm = -1;
  endcredit_et = -1;
  endcredit_st = -1;
  menudisplay_st = -1;
  epg_type = '';
  epg_url = ''
  episode: string = '';
  feed_type = '';
  feed = '';
  gender = '';
  highlight = -1;
  hero_image='';
  id = '';
  intro_et = -1;
  intro_st = -1;
  like_count = false;
  main_picture = '';
  node_id = '';
  path_alias = '';
  picture = '';
  popularity_rating: number = -1;
  primary_category: string | null = null;
  primary_genre = '';
  publisher = '';
  rating_average = '';
  rating_count = '';
  release_date = '';
  runtime: number | null = null;
  season: string = '';
  series_name: string | null = null;
  subCatId = '';
  title = '';
  type = '';
  uid = '';
  updated = '';
  url = '';
  user_rating = '';
  video_flv_url: string | null = null;
  video_format = '';
  video_hls_url: string | null = null;
  video_url = '';
  mood_tags: string | null = null;
  likedislike: number| null = null
}
